/* eslint-disable react/display-name */

import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button
} from "reactstrap"
import DatatableTables from "components/tables/DatatableTables";
import { get } from 'helpers/api_helper'
import { REPORTS_URL } from 'helpers/url_helper'
import moment from 'moment'
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"
import DynamicMonthAttendanceTable from "./DynamicMonthAttendanceTable";

const Timezone = (dateString) => {    
  const date = moment(dateString).toDate();
  return moment(date).format('YYYY-MM-DD');;
}

const MonthlyReport = () => {
    const [data, setData] = useState([])
    const [filters, setFilters] = useState({
      date: [moment().format('yyyy-MM-DD')]
    })

    const fetchData = async() => {
      const queryString = new URLSearchParams(filters).toString();
      const res = await get(`${REPORTS_URL}/monthly?${queryString}`);
      if(res.success){
        setData([])
        setData(res.body)
      }
    }

    useEffect(() =>{
        fetchData();
    }, [filters])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Reports | Advance Dental Export Canteen Management</title>
                </MetaTags>
                <Container fluid>
                  <Card>
                    <CardBody>
                      <DynamicMonthAttendanceTable employees={data} byMonth={(date) => {
                        setFilters(p => ({...p, date: [moment(date).format('yyyy-MM')]}))
                      }} />
                    </CardBody>
                  </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default MonthlyReport;
